import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const updateEmailCacheKey = 'updateEmail';
export const updateEmailDocument = /* GraphQL */ `
    mutation UpdateEmail($formFields: UpdateEmailFormFields!) {
        updateEmail(formFields: $formFields) {
            success
            message
            errors
        }
    }
`;
export const updateEmailMutation = graphql(updateEmailDocument);
